



































import { Component, Vue } from 'vue-property-decorator';
import AdminQuestionContainer from '@/components/admin-questions/AdminQuestionContainer.vue';
import QuestionsAdminStore, {
  QuestionsAdminStoreInterface,
} from '@/resource/question/questions-admin.store';
import { getRole } from '@/utils/cookie';
import { UserRole } from '@/resource/user/user.model';
import Toggle from '@/components/common/Toggle.vue';
import { questionTypeToggles } from '@/utils/add-question/add-question-constant';
import LoadingBox from '@/components/common/LoadingBox.vue';

@Component({
  components: { AdminQuestionContainer, Toggle, LoadingBox },
})
export default class AdminQuestion extends Vue {
  questionsStore: QuestionsAdminStoreInterface = QuestionsAdminStore;
  isLoading = true;
  questionTypeToggles = questionTypeToggles;

  selectedQuestionType = 0;

  get userRole(): UserRole | null {
    return getRole();
  }

  get subjectUuid() {
    return this.$route.params.uuid;
  }

  get adminObjectives() {
    return this.questionsStore.adminObjectives;
  }

  get adminSubjectives() {
    return this.questionsStore.adminSubjectives;
  }

  async created() {
    await this.fetchAdminQuestions();
  }

  async fetchAdminQuestions() {
    this.isLoading = true;
    await this.questionsStore.fetchQuestions(this.subjectUuid);
    this.isLoading = false;
  }

  updateQuestionType(index: number) {
    this.selectedQuestionType = index;
  }
}
